import { useNavigate } from "react-router-dom";
import { XCircle, Zap } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import Logo from "../components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 p-8 text-center" data-testid="payment-cancel-page">
        <Link to="/dashboard" className="flex items-center justify-center gap-2 mb-6">
          <Logo size="sm" />
        </Link>
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mx-auto"><XCircle className="w-9 h-9 text-slate-400" /></div>
        <h1 className="font-display text-2xl font-extrabold text-slate-900 mt-4">Payment cancelled</h1>
        <p className="text-slate-500 mt-2">No charge was made. Your bill is still waiting whenever you're ready.</p>
        <Button onClick={() => navigate("/dashboard")} className="w-full mt-6 rounded-full bg-emerald-500 hover:bg-emerald-600 font-bold">Back to dashboard</Button>
      </div>
    </div>
  );
}
